import { handleAction, createAction } from 'redux-actions';
import { getDataProvider } from '../../data-providers';

export const setNavigationFlow = createAction('SET_NAVIGATION_FLOW');

export const tellNativePageChanged = createAction('TELL_NATIVE_PAGE_CHANGED', (oldPage, newPage) => {
  return getDataProvider().tellNativePageChanged(oldPage, newPage);
});

export default handleAction(setNavigationFlow, (state, action) => action.payload, { flowType: 'general' });
